module.exports = __webpack_public_path__ + "img/icon_site_detail_active.c4a49abf.png";